import { render, staticRenderFns } from "./switch-widget.vue?vue&type=template&id=0c9c578a&scoped=true"
import script from "./switch-widget.vue?vue&type=script&lang=js"
export * from "./switch-widget.vue?vue&type=script&lang=js"
import style0 from "./switch-widget.vue?vue&type=style&index=0&id=0c9c578a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9c578a",
  null
  
)

export default component.exports